// ─── Date & String Helpers ────────────────────────────────────────────────────

export const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

export const toCamelCase = (str) => {
    if (!str) return "";
    return str.toLowerCase().replace(/[-_ ]+(.)/g, (_, c) => c.toUpperCase());
};

// ─── Pagination ───────────────────────────────────────────────────────────────

export const getPageNumbers = (totalPages) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) pages.push(i);
    return pages;
};
